import { render, staticRenderFns } from "./server-pople-detail.vue?vue&type=template&id=e451df3a&scoped=true"
import script from "./server-pople-detail.vue?vue&type=script&lang=js"
export * from "./server-pople-detail.vue?vue&type=script&lang=js"
import style0 from "./server-pople-detail.vue?vue&type=style&index=0&id=e451df3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e451df3a",
  null
  
)

export default component.exports